import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import Icon from '../Icon';
import QuantityInput from '../QuantityInput/QuantityInput';
import clsx from 'clsx';

interface BackInStockButtonProps {
  onButtonClick: () => void;
}

const BackInStockButton: React.FC<BackInStockButtonProps> = ({
  onButtonClick,
}) => {
  return (
    <div className={clsx('', 'flex gap-2')}>
      <QuantityInput quantity={0} showButtons={true} className="flex-1" />
      <button
        className="w-full btn btn--primary btn--large flex gap-4 flex-grow self-stretch relative bg-primary-500 border border-solid border-primary-500 font-satoshi-bold font-satoshi hover:bg-primary-500 hover:border-primary-500 opacity-80 text-white"
        onClick={onButtonClick}
      >
        <Icon
          name="mail-white"
          aria-label={translate('out-of-stock-openmodal')}
          className="!w-6 !h-6"
        />{' '}
        <span>{translate('out-of-stock-openmodal')}</span>
      </button>
    </div>
  );
};

export default BackInStockButton;
